import http from './http'
import { handleHttpError } from './httpHelpers'

export function writeReviewService(data) {
    let pdata = {
        "customFunc": {
            "name": "cf_scriviRecensione",
            "param": { ...data }
        }
    }

    return http.post('/api/v1/recensione/customfunc/', pdata, { skipAuthRefresh: true }).then(res => {
        return res.data
    }).catch(e => {
        return handleHttpError(e)
    })
}

export function getReviewService(data) {
    let pdata = {
        "customFunc": {
            "name": "cf_ottieniRecensioni",
            "param": { ...data }
        }
    }

    return http.post('/api/v1/recensione/customfunc/', pdata, { skipAuthRefresh: true }).then(res => {
        return res.data
    }).catch(e => {
        return handleHttpError(e)
    })
}